import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Loader2, Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/subscribe`, { email });
      toast.success("¡Gracias! Te mantendremos al día de las novedades de E².");
      setEmail("");
    } catch (err) {
      if (err.response?.status === 409) {
        toast.info("Este correo ya está suscrito.");
      } else {
        toast.error("No se pudo completar la suscripción. Inténtalo de nuevo.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-espana-gold">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid lg:grid-cols-2 gap-8 items-center">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-espana-red mb-3">
            Adhesión al proyecto
          </p>
          <h2 className="text-3xl sm:text-4xl font-black tracking-tight text-[#111827]">
            Recibe las novedades y nuevos Policy Briefs.
          </h2>
          <p className="mt-3 text-[#111827]/70 max-w-lg">
            Sin spam. Solo avisos cuando publicamos análisis o avances del
            proyecto. Puedes darte de baja cuando quieras.
          </p>
        </div>
        <form onSubmit={submit} data-testid="newsletter-form" className="flex flex-col sm:flex-row gap-3">
          <div className="relative flex-1">
            <Mail size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="newsletter-email"
              placeholder="tu@correo.es"
              className="w-full bg-white border border-transparent rounded-sm pl-10 pr-4 py-3.5 focus:outline-none focus:ring-2 focus:ring-espana-red transition-shadow"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="newsletter-submit"
            className="inline-flex items-center justify-center gap-2 bg-espana-red hover:bg-espana-reddark disabled:opacity-60 text-white font-bold px-6 py-3.5 rounded-sm transition-colors"
          >
            {loading ? <Loader2 size={18} className="animate-spin" /> : <Send size={18} />}
            Suscribirme
          </button>
        </form>
      </div>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 -mt-6 pb-8">
        <a
          href="/baja"
          data-testid="newsletter-unsubscribe"
          className="text-sm text-[#111827]/60 hover:text-espana-red underline transition-colors"
        >
          ¿Ya no quieres recibir el boletín? Darse de baja
        </a>
      </div>
    </section>
  );
}
